/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from 'react-query';
import httpClient from 'utils/httpClient';

const TIME_ZONE = '/v1/pre-requisites';

export type TimeZoneResponse = {
  _data: {
    timezone: any;
  };
};

export const retrieveTimeZone = () =>
  httpClient.get(TIME_ZONE, {
    params: {
      timezone: true,
    },
  });
export const useRetrieveTimeZone = (
  opts?: UseQueryOptions<AxiosResponse<TimeZoneResponse>, AxiosError<any>>,
) =>
  useQuery<AxiosResponse<TimeZoneResponse>, AxiosError<any>>(
    [TIME_ZONE],
    () => retrieveTimeZone(),
    { ...opts, cacheTime: 0 },
  );
